'use client'

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'
import { useUser } from '@clerk/nextjs'
import { usePostHogIdentify } from '@/hooks/usePostHogIdentify'
import { useUserProfile } from '@/hooks/useUserProfile'

// Initialize PostHog client-side only
if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_POSTHOG_KEY) {
  try {
    posthog.init(process.env.NEXT_PUBLIC_POSTHOG_KEY, {
      api_host: '/ingest',
      ui_host: process.env.NEXT_PUBLIC_POSTHOG_UI_HOST || 'https://us.posthog.com',
      person_profiles: 'always',
      capture_pageview: false,
      capture_pageleave: true,
      session_recording: {
        maskAllInputs: false,
        maskInputFn: (text, element) => {
          // Mask password fields only
          if (element?.getAttribute('type') === 'password') {
            return '*'.repeat(text.length)
          }
          return text
        },
      },
      capture_performance: true,
      loaded: () => {
        if (process.env.NODE_ENV === 'development') {
          console.log('PostHog loaded successfully')
        }
      }
    })
  } catch (error) {
    console.error('Failed to initialize PostHog:', error)
  }
}

function PostHogIdentifier() {
  const { user } = useUser()
  const { profile } = useUserProfile()

  usePostHogIdentify(user, profile)

  return null
}

export function PHProvider({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider client={posthog}>
      <PostHogIdentifier />
      {children}
    </PostHogProvider>
  )
}